import React from 'react'
import EyeCatchingImage, { EyeCatchingImageProps } from 'molecules/media/EyeCatchingImage'
import RichContentsCard, { RichContentsCardProps } from 'molecules/display/RichContentsCard'
import Grid from 'atoms/layout/Grid'
import Typography from 'atoms/display/Typography'
import Box from 'atoms/layout/Box'

export type SimpleRichContentsProps = EyeCatchingImageProps & RichContentsCardProps & {
  title: string
  noEyeCatching?: boolean;
}

export default function SimpleRichContents ({
  url, content, title, noEyeCatching
}: SimpleRichContentsProps) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h4">
          {title}
        </Typography>
      </Grid>
      { !noEyeCatching && (
        <Grid item xs={12}>
          <EyeCatchingImage url={url}/>
        </Grid>
      ) }
      <Grid item xs={12}>
        <Box px={4}>
          <RichContentsCard content={content}/>
        </Box>
      </Grid>
    </Grid>
  )
}
